import { Component, Fragment, Prop, h } from '@stencil/core';
import { FinanceOption, PrivatLeasing } from '../../types';
import { formatNumber } from '../../utils/helpers';
import state from '../../store';

@Component({
  tag: 'kia-privatleasing',
})
export class Priskort {
  @Prop() data: PrivatLeasing;
  @Prop() tax: number = 360;
  @Prop() showPrice: boolean = true;

  render() {
    return (
      <div class="kia_price_card--module">
        {this.showPrice ? (
          <Fragment>
            <h5>
              Privatleasing inkl. serviceavtal ²<kia-tooltip toolTitle="36 mån 3000 mil" />
            </h5>
            <p>Från {formatNumber(this.data.manadshyra363000 ?? this.data.incl_service_agreement)} kr/mån</p>
          </Fragment>
        ) : (
          <Fragment>
            <p>
              <strong>Privatleasing inkl. serviceavtal</strong>
            </p>
            <p>
              <a style={{ textDecoration: 'underline' }} href="https://www.kia.com/se/sok-aterforsaljare-verkstad">
                Kontakta återförsäljare
              </a>{' '}
              för prisuppgift
            </p>
          </Fragment>
        )}
        {state.activeFinanceOption === FinanceOption.PrivatLeasing && this.showPrice && (
          <Fragment>
            <p>
              <strong>
                Privatleasing inkl. första förhöjd hyra 10% ⁴<kia-tooltip toolTitle="Inkl. serviceavtal inkl. serviceavtal" />
              </strong>
            </p>
            <p>{formatNumber(this.data.manadshyra_10_1_000_mil_3000 ?? this.data.incl_first_increased_rent)} kr/mån</p>
            <p>
              <strong>Fordonsskatt per år</strong>
            </p>
            <p>{this.tax} kr</p>
          </Fragment>
        )}
      </div>
    );
  }
}
